module.exports = __webpack_public_path__ + "img/Z82_17.73afafc3.jpg";